import { render } from "./UiCaption.vue?vue&type=template&id=f972e96e&ts=true"
import script from "./UiCaption.vue?vue&type=script&lang=ts"
export * from "./UiCaption.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ni/IdeaProjects/pioneer/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__